
export const isRunningInExtension = /[a-z]+(\-extension)/i.test(window.location.href);

export const isRunningInExtensionsDevToolsPanel = isRunningInExtension && window.location.href.includes('devtools-panel.html');
export const isRunningInExtensionsSidePanel = isRunningInExtension && window.location.href.includes('side-panel.html');